import { useEffect } from "react";
import { useHistory, useLocation } from "react-router";
// This exists so that navigating to an already active route still forces that route to
// be reset to its initial state (i.e. the component is unmounted and remounted).
// Navigation links route here, but with the state value being actual destination route.
// This component immediately navigates to the actual destination route (replacing history).
function ReloadRoute() {
    const { state } = useLocation();
    const { replace } = useHistory();
    useEffect(() => {
        replace(state as string);
    })
    return (<></>);
}
export default ReloadRoute;
